<div class="EFFilter">
    <div class="EFFilter-Inner mt-2">
        @if (!lockFilter && !lockFilterType) {
            <div>
                <div class="d-flex">
                    @if (hasSelectableCategories(filterData.type) || hasFilterTypeStars(filterData.type) || hasFilterTypeCost(filterData.type)) {
                        <div class="ps-2 mb-2 EFFilter-Toggle {{filterCollapsed ? 'EFFilter-Toggle--Collapsed' : ''}}">
                            <div class="d-inline-block bg-white shadow-sm rounded">
                                <button type="button" class="btn btn-white {{filterCollapsed ? '' : 'btn-white-selected'}}" (click)="filterCollapsed = !filterCollapsed" [attr.aria-expanded]="!filterCollapsed" [attr.aria-label]="'experience-finder.a11y.filter-toggle' | locTranslate">
                                    <i class="fa-regular fa-filter" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    }
                    <div class="EFFilter-Tabs pb-2">
                        <div class="d-inline-block bg-white shadow-sm rounded btn-group mx-2" role="group">
                            @if (availableTypes != null) {
                                @if(mixTypes) {
                                    <button type="button" class="btn text-center btn-white EFFilter-Tabs-Button {{filterData.type == null ? 'btn-white-selected' : ''}}" (click)="setFilterDataType(null)" [attr.aria-pressed]="filterData.type == null">
                                        <div class="d-none d-lg-block">
                                            <div>
                                                <i class="fa-regular fa-lg text-center fa-asterisk" aria-hidden="true"></i>
                                            </div>
                                            <span>{{ 'experience-finder.general.product-type-all' | locTranslate }}</span>
                                        </div>
                                        <span class="d-lg-none">
                                            <i class="fa-regular fa text-center fa-asterisk" aria-hidden="true"></i>&nbsp;{{ 'experience-finder.general.product-type-all' | locTranslate }}
                                        </span>
                                    </button>
                                }
                                @for (type of availableTypes; track type) {
                                    @if (!isTypeHidden(type)) {
                                        <button type="button" class="btn text-center btn-white EFFilter-Tabs-Button {{filterData.type == type ? 'btn-white-selected' : ''}}" (click)="setFilterDataType(type)" [attr.aria-pressed]="filterData.type == type">
                                            <div class="d-none d-lg-block">
                                                <div>
                                                    <i class="fa-regular fa-lg text-center" [innerHTML]="getTypeIcon(type)" aria-hidden="true"></i>
                                                </div>
                                                <span>{{ 'experience-finder.general.product-type-' + type | locTranslate }}</span>
                                            </div>
                                            <span class="d-lg-none">
                                                <i class="fa-regular fa text-center" [innerHTML]="getTypeIcon(type)" aria-hidden="true"></i>&nbsp;{{ 'experience-finder.general.product-type-' + type | locTranslate }}
                                            </span>
                                        </button>
                                    }
                                }
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="align-items-center d-block position-relative">
            <div class="{{lockFilter ? 'EFFilter-Inner--Locked' : ''}}">
                @if (!lockFilter && filterData.type != null) {
                    <div class="EFFilter-Inner-Buttons">
                        <div class="d-flex">
                            @if (hasSelectableCategories(filterData.type)) {
                                @if (filterData.category[filterData.type]; as categories) {
                                    <div class="ps-2 {{filterCollapsed ? 'EFFilter-Item--Collapsed' : ''}}">
                                        <div class="d-inline-block bg-white shadow-sm rounded mb-2">
                                            <div class="d-inline-block" ngbDropdown [autoClose]="'outside'">
                                                <button ngbDropdownToggle class="btn btn-white">
                                                    @if (categoriesList[filterData.type]; as list) {
                                                        <span>
                                                            {{getCategoryListDisplay(filterData.type)}}
                                                        </span>
                                                    }
                                                </button>
                                                <div ngbDropdownMenu class="EFFilter-Inner-Menu">
                                                    <div class="dropdown-item" (click)="toggleAllCategories(filterData.type)">
                                                        <app-pg-switch [small]="true" [ngModel]="filterData.allCategories"></app-pg-switch>
                                                        <label class="ms-2 mb-0">
                                                            <i class="{{getCategoryIcon(filterData.type, '*')}}"></i>
                                                            {{getCategoryTranslation(filterData.type, '*')}}
                                                        </label>
                                                    </div>
                                                    <hr class="my-1"/>
                                                    @for (item of categories | keyvalue: sortCategoriesAltroLast; track item.key) {
                                                        <div class="dropdown-item" (click)="toggleCategory(filterData.type, item.key)">
                                                            <app-pg-switch [small]="true" [ngModel]="categories[item.key]"></app-pg-switch>
                                                            <label class="ms-2 mb-0">
                                                                <i class="{{getCategoryIcon(filterData.type, item.key)}}"></i>
                                                                {{getCategoryTranslation(filterData.type, item.key)}}
                                                            </label>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                            @if (hasSelectableSubcategories(filterData.type)) {
                                @if (filterData.category[filterData.type]; as categories) {
                                    @if (filterData.subcategory[filterData.type]; as subcategories) {
                                        <div class="ps-2 {{filterCollapsed ? 'EFFilter-Item--Collapsed' : ''}}">
                                            <div class="d-inline-block bg-white shadow-sm rounded mb-2">
                                                <div class="d-inline-block" ngbDropdown [autoClose]="'outside'">
                                                    <button ngbDropdownToggle class="btn btn-white">
                                                        @if (subcategoriesList[filterData.type]; as list) {
                                                            <span>
                                                                {{getSubcategoryListDisplay(filterData.type)}}
                                                            </span>
                                                        }
                                                    </button>
                                                    <div ngbDropdownMenu class="EFFilter-Inner-Menu">
                                                        <div class="dropdown-item" (click)="toggleAllSubcategories(filterData.type)">
                                                            <app-pg-switch [small]="true" [ngModel]="filterData.allSubcategories"></app-pg-switch>
                                                            <label class="ms-2 mb-0">
                                                                {{getSubcategoryTranslation(filterData.type, '*')}}
                                                            </label>
                                                        </div>
                                                        <hr class="my-1"/>
                                                        @for (parent of subcategories | keyvalue: sortCategoriesAltroLast; track parent.key) {
                                                            @if (filterData.allCategories || categories[parent.key]) {
                                                                @for (item of parent.value | keyvalue: sortSubcategoriesAltroLast; track item.key) {
                                                                    <div class="dropdown-item" (click)="toggleSubcategory(filterData.type, parent.key, item.key)">
                                                                        <app-pg-switch [small]="true" [ngModel]="subcategories[parent.key][item.key]"></app-pg-switch>
                                                                        <label class="ms-2 mb-0">
                                                                            {{getSubcategoryTranslation(filterData.type, item.key)}}
                                                                        </label>
                                                                    </div>
                                                                }
                                                            }
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                }
                            }
                            @if (hasFilterTypeStars(filterData.type)) {
                                @if (filterData.stars[filterData.type]; as stars) {
                                    <div class="ps-2 {{filterCollapsed ? 'EFFilter-Item--Collapsed' : ''}}">
                                        <div class="d-inline-block bg-white shadow-sm rounded mb-2">
                                            <div class="d-inline-block" ngbDropdown [autoClose]="'outside'">
                                                <button ngbDropdownToggle class="btn btn-white">
                                                    <span>
                                                        {{getStarsListDisplay(filterData.type)}}
                                                    </span>
                                                </button>
                                                <div ngbDropdownMenu class="EFFilter-Inner-Menu">
                                                    <div class="dropdown-item" (click)="toggleAllStars(filterData.type)">
                                                        <app-pg-switch [small]="true" [ngModel]="filterData.allStars"></app-pg-switch>
                                                        <label class="ms-2 mb-0">{{ 'experience-finder.ef-filter.stars-all' | locTranslate}}</label>
                                                    </div>
                                                    <hr class="my-1"/>
                                                    @for (item of stars | keyvalue; track item) {
                                                        <div class="dropdown-item" (click)="toggleStars(filterData.type, item.key)">
                                                            <app-pg-switch [small]="true" [ngModel]="stars[item.key]"></app-pg-switch>
                                                            <label class="ms-2 mb-0">
                                                                <small class="opacity-80" [innerHTML]="getStarsLabel(item.key)"></small>
                                                            </label>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                            @if (hasFilterTypeCost(filterData.type)) {
                                @if (filterData.cost[filterData.type]; as cost) {
                                    <div class="ps-2 {{filterCollapsed ? 'EFFilter-Item--Collapsed' : ''}}">
                                        <div class="d-inline-block bg-white shadow-sm rounded mb-2">
                                            <div class="d-inline-block" ngbDropdown [autoClose]="'outside'">
                                                <button ngbDropdownToggle class="btn btn-white">
                                                    <span>
                                                        {{getCostListDisplay(filterData.type)}}
                                                    </span>
                                                </button>
                                                <div ngbDropdownMenu class="EFFilter-Inner-Menu">
                                                    <div class="dropdown-item" (click)="toggleAllCosts(filterData.type)">
                                                        <app-pg-switch [small]="true" [ngModel]="filterData.allCosts"></app-pg-switch>
                                                        <label class="ms-2 mb-0">{{ 'experience-finder.ef-filter.cost-all' | locTranslate}}</label>
                                                    </div>
                                                    <hr class="my-1"/>
                                                    @for (item of cost; track item; let i = $index) {
                                                        <div class="dropdown-item" (click)="toggleCost(filterData.type, i)">
                                                            <app-pg-switch [small]="true" [ngModel]="item.selected"></app-pg-switch>
                                                            <label class="ms-2 mb-0">
                                                                {{getCostLabel(item)}}
                                                            </label>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                            @if (hasFilterTypePast(filterData.type)) {
                                <div class="ps-2 EFFilter-Item-Switch">
                                    <div class="d-inline-block bg-white shadow-sm rounded mb-2">
                                        <div class="d-inline-block">
                                            <button class="btn btn-white d-flex" (click)="togglePast(filterData.type)">
                                                <app-pg-switch [small]="true" [ngModel]="filterData.past[filterData.type]"></app-pg-switch>
                                                <label class="ms-2 mb-0">{{ 'experience-finder.ef-filter.past-' + filterData.type | locTranslate}}</label>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                            @if(hasCumulativeBooking()) {
                                <div class="ps-2">
                                    <button class="btn btn-link bg-white shadow-sm" [disabled]="isCumulativeBooking" (click)="doCumulativeBooking()">
                                        <i class="fa-regular fa-tag"></i>
                                        <span>{{ 'experience-finder.general.mass-booking' | locTranslate }}</span>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                }
                <!--
                <div class="px-2 mb-1 EFFilter-Inner-Language">
                    <div *ngIf="filterData.language[filterData.type]; let languages" class="d-inline-block bg-white shadow-sm rounded">
                        <div class="d-inline-block" ngbDropdown [autoClose]="'outside'" placement="bottom-right">
                            <button ngbDropdownToggle class="btn btn-white">
                                <span>
                                    {{getLanguageListDisplay(filterData.type)}}
                                </span>
                            </button>
                            <div ngbDropdownMenu class="EFFilter-Inner-Menu">
                                <div *ngFor="let item of languages | keyvalue" class="dropdown-item" (click)="toggleLanguage(filterData.type, item.key);">
                                    <app-pg-switch [small]="true" [ngModel]="item.value"></app-pg-switch>
                                    <label class="ms-2 mb-0">
                                        <span>{{getLanguageLabel(item.key)}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                -->
            </div>
            @if(hasCumulativeBooking() && lockFilter) {
                <div class="ps-2">
                    <button class="btn btn-link bg-white shadow-sm" [disabled]="isCumulativeBooking" (click)="doCumulativeBooking()">
                        <i class="fa-regular fa-tag"></i>
                        <span>{{ 'experience-finder.general.mass-booking' | locTranslate }}</span>
                    </button>
                </div>
            }
        </div>
    </div>
</div>
